import { Zone } from 'entities/Zone';

export interface ZoneFormDrawerSchema {
  mode: Nullable<DrawerMode>;
  zone?: Nullable<Zone>;
}

export enum DrawerMode {
  ZONE_EDIT = 'zone_edit',
  ZONE_CREATE = 'zone_create',
}

export enum ZonesEditKeys {
  userIds = 'userIds',
  objectIds = 'objectIds',
}
